"use client";

/**
 * Brand 도메인 TanStack Query 훅
 *
 * productService의 getBrandProducts/getBrandInfo 래핑
 */
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { createProductService } from "@/shared/api/services/productService";
import { useBuyerService } from "@/shared/auth/hooks";

import { brandKeys } from "@/features/brand/queries/keys";

interface UseBrandProductsParams {
  idBrand: string;
  page?: number;
  order?: string;
  search?: string;
}

export function useBrandProducts(params: UseBrandProductsParams) {
  const service = useBuyerService(createProductService);

  return useQuery({
    queryKey: brandKeys.products(
      params.idBrand,
      `${params.page ?? 1}-${params.order ?? "best"}-${params.search ?? ""}`,
    ),
    queryFn: () => service.getBrandProducts(params),
    placeholderData: keepPreviousData,
    enabled: !!params.idBrand,
  });
}

export function useBrandInfo(brandId: string) {
  const service = useBuyerService(createProductService);

  return useQuery({
    queryKey: brandKeys.info(brandId),
    queryFn: () => service.getBrandInfo(brandId),
    enabled: !!brandId,
  });
}
